module.exports = __webpack_public_path__ + "610622904e61fd75b953988b442b3aef.pdf";